<template>
  <div id="F0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <div v-if="this.errorMessage.text" class="error_text">{{this.errorMessage.text}}</div>
            <div v-if="this.validateErrorMessages">
              <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
            </div>
            <div v-if="this.surveyType === 0">
              <h1 class="tit1">アンケート</h1>
              <p class="lead_upper">
                ご回答いただいた方に漏れなく<br>
                <strong>1,000円分のディスカウントクーポンをプレゼント！</strong>
              </p>
              <ul class="lst_register">
                <li>
                  <div class="item">
                    <label for="survey1_1">【居住形態】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <div class="ins_wrap">
                      <select id="survey1_1" name="survey1_1" class="sel" v-model="surveyFormA.residentsSelected">
                        <option v-for="(item,index) in residentsOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                    </div>
                    <div class="sel_wrap" v-show="isFamilySelected">
                      <label for="survey1_2">人数：</label>
                      <select id="survey1_2" name="survey1_2" class="sel" v-model="surveyFormA.peopleSelected">
                        <option v-for="(item,index) in numberOfPeopleOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                    </div>
                    <div class="sel_wrap" v-show="isFamilySelected">
                      <label for="survey1_3">うち子ども：</label>
                      <select id="survey1_3" name="survey1_3" class="sel" v-model="surveyFormA.childSelected">
                        <option v-for="(item,index) in numberOfPeopleOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    【持ち家／賃貸】<strong class="req">※必須</strong>
                  </div>
                  <div class="cnt">
                    <div class="raido_wrap">
                      <input type="radio" id="survey2_1" name="survey2" value="1" class="rad" v-model="surveyFormA.rentSelected"><label for="survey2_1" class="lbl_rad">持ち家</label>
                    </div>
                    <div class="raido_wrap">
                      <input type="radio" id="survey2_2" name="survey2" value="2" class="rad" v-model="surveyFormA.rentSelected"><label for="survey2_2" class="lbl_rad">賃貸</label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    【戸建て／マンション／その他】<strong class="req">※必須</strong>
                  </div>
                  <div class="cnt">
                    <div class="raido_wrap">
                      <input type="radio" id="survey3_1" name="survey3" value="1" class="rad" v-model="surveyFormA.housingTypesSelected"><label for="survey3_1" class="lbl_rad">戸建て</label>
                    </div>
                    <div class="raido_wrap">
                      <input type="radio" id="survey3_2" name="survey3" value="2" class="rad" v-model="surveyFormA.housingTypesSelected"><label for="survey3_2" class="lbl_rad">マンション</label>
                    </div>
                    <div class="raido_wrap">
                      <input type="radio" id="survey3_3" name="survey3" value="3" class="rad" v-model="surveyFormA.housingTypesSelected"><label for="survey3_3" class="lbl_rad">その他</label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    【新築／中古】<strong class="req">※必須</strong>
                  </div>
                  <div class="cnt">
                    <div class="raido_wrap">
                      <input type="radio" id="survey4_1" name="survey4" value="1" class="rad" v-model="surveyFormA.existingHouseSelected"><label for="survey4_1" class="lbl_rad">新築</label>
                    </div>
                    <div class="raido_wrap">
                      <input type="radio" id="survey4_2" name="survey4" value="2" class="rad" v-model="surveyFormA.existingHouseSelected"><label for="survey4_2" class="lbl_rad">中古</label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey5">【間取り】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <div class="sel_wrap2">
                      <select id="survey5" name="survey5" class="sel" v-model="surveyFormA.floorSelected">
                        <option v-for="(item,index) in floorOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey6">【広さ】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <div class="sel_wrap2">
                      <select id="survey6" name="survey6" class="sel" v-model="surveyFormA.areaSelected">
                        <option v-for="(item,index) in areaOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey7">【築年数】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <div class="sel_wrap2">
                      <select id="survey7" name="survey7" class="sel" v-model="surveyFormA.ageSelected">
                        <option v-for="(item,index) in ageOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                      </select>
                      <span class="unit type2">年</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="this.surveyType === 1">
              <h1 class="tit1">アンケート</h1>
              <p class="lead_upper">
                ご回答いただいた方に漏れなく<br>
                <strong>1,000円分のディスカウントクーポンをプレゼント！</strong>
              </p>
              <ul class="lst_register">
                <li>
                  <div class="item">
                    <label for="survey1">【家具が欲しい場所】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey1" name="survey1" class="sel" v-model="surveyFormB.placeSelected">
                      <option v-for="(item,index) in placeOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey2">【家具が欲しい時期】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey2" name="survey2" class="sel" v-model="surveyFormB.timingSelected">
                      <option v-for="(item,index) in timingOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey3">【予算】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey3" name="survey3" class="sel" v-model="surveyFormB.estimateSelected">
                      <option v-for="(item,index) in estimateOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey4">【部屋のイメージ】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey4" name="survey4" class="sel" v-model="surveyFormB.roomImageSelected">
                      <option v-for="(item,index) in roomImageOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey5">【趣味】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey5" name="survey5" class="sel" v-model="surveyFormB.hobbySelected">
                      <option v-for="(item,index) in hobbyOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="item">
                    <label for="survey6">【好みの家具】<strong class="req">※必須</strong></label>
                  </div>
                  <div class="cnt">
                    <select id="survey6" name="survey6" class="sel" v-model="surveyFormB.tasteSelected">
                      <option v-for="(item,index) in tasteOption" :key="index" v-bind:value="item.key">{{item.value}}</option>
                    </select>
                  </div>
                </li>
              </ul>
            </div>
            <div class="btn_area">
              <a class="btn1" @click="send()">送信する</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import {KG_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      surveyType: 0,
      residentsOption: [
        {key: 1, value: '家族'},
        {key: 2, value: '一人暮らし'},
        {key: 3, value: 'カップル'},
        {key: 4, value: 'シェア'},
        {key: 5, value: 'その他'}
      ],
      numberOfPeopleOption: [
        {key: 1, value: '1人'},
        {key: 2, value: '2人'},
        {key: 3, value: '3人'},
        {key: 4, value: '4人'},
        {key: 5, value: '5人'},
        {key: 6, value: '6人'},
        {key: 7, value: '7人'},
        {key: 8, value: '8人'},
        {key: 9, value: '9人'},
        {key: 10, value: '10人以上'}
      ],
      floorOption: [
        {key: 1, value: '1R'},
        {key: 2, value: '1K'},
        {key: 3, value: '1DK'},
        {key: 4, value: '1LDK'},
        {key: 5, value: '2K'},
        {key: 6, value: '2DK'},
        {key: 7, value: '2LDK'},
        {key: 8, value: '3K'},
        {key: 9, value: '3DK'},
        {key: 10, value: '3LDK'},
        {key: 11, value: '4K'},
        {key: 12, value: '4DK'},
        {key: 13, value: '4LDK'},
        {key: 14, value: 'その他'}
      ],
      areaOption: [
        {key: 1, value: '50㎡以下'},
        {key: 2, value: '50㎡〜100㎡'},
        {key: 3, value: '100㎡〜150㎡'},
        {key: 4, value: '150㎡〜200㎡'},
        {key: 5, value: '200㎡以上'}
      ],
      ageOption: [
        {key: 1, value: '1年以下'},
        {key: 2, value: '1年〜5年'},
        {key: 3, value: '5年〜10年'},
        {key: 4, value: '10年〜15年'},
        {key: 5, value: '15年〜20年'},
        {key: 6, value: '20年以上'}
      ],
      rentRadio: [
        {key: '1', value: '持ち家'},
        {key: '2', value: '賃貸'}
      ],
      housingTypesRadio: [
        {key: '1', value: '戸建て'},
        {key: '2', value: 'マンション'},
        {key: '3', value: 'その他'}
      ],
      existingHouseRadio: [
        {key: '1', value: '新築'},
        {key: '2', value: '中古'}
      ],
      placeOption: [
        {key: 1, value: 'キッチン'},
        {key: 2, value: 'リビング・ダイニング'},
        {key: 3, value: 'ベッドルーム'},
        {key: 4, value: 'キッズ'},
        {key: 5, value: '書斎'},
        {key: 6, value: 'トイレ・バス・洗面'},
        {key: 7, value: '玄関'},
        {key: 8, value: '壁面収納・システム'},
        {key: 9, value: 'その他'}
      ],
      timingOption: [
        {key: 1, value: 'できるだけ早く'},
        {key: 2, value: '3ヶ月以内'},
        {key: 3, value: '半年以内'},
        {key: 4, value: '1年以内'}
      ],
      estimateOption: [
        {key: 1, value: '1万円〜10万円'},
        {key: 2, value: '10万円〜30万円'},
        {key: 3, value: '30万円〜50万円'},
        {key: 4, value: '50万円以上'}
      ],
      roomImageOption: [
        {key: 1, value: 'オールドファッション'},
        {key: 2, value: 'モダンスタイル'}
      ],
      hobbyOption: [
        {key: 1, value: '映画鑑賞'},
        {key: 2, value: '音楽鑑賞'},
        {key: 3, value: '読書'},
        {key: 4, value: '料理'},
        {key: 5, value: '釣り'}
      ],
      tasteOption: [
        {key: 1, value: '和風'},
        {key: 2, value: 'アジアンテイスト'},
        {key: 3, value: 'ヨーロピアン'}
      ],
      surveyForm: {
        // 各アンケートの内容を設定する
      },
      surveyFormA: {
        // アンケートAの選択
        residentsSelected: 1,
        peopleSelected: 4,
        childSelected: 2,
        floorSelected: 3,
        areaSelected: 3,
        ageSelected: 2,
        rentSelected: '1',
        housingTypesSelected: '1',
        existingHouseSelected: '1'
      },
      surveyFormB: {
        // アンケートBの選択
        placeSelected: 2,
        timingSelected: 2,
        estimateSelected: 2,
        roomImageSelected: 2,
        hobbySelected: 1,
        tasteSelected: 3
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    send: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.surveyForm = {}
      if (this.surveyType === 0) {
        this.surveyForm.residents = this.residentsSelectedValue
        this.surveyForm.people = this.peopleSelectedValue
        this.surveyForm.child = this.childSelectedValue
        this.surveyForm.floor = this.floorSelectedValue
        this.surveyForm.area = this.areaSelectedValue
        this.surveyForm.age = this.ageSelectedValue
        this.surveyForm.rent = this.rentSelectedValue
        this.surveyForm.housingTypes = this.housingTypesSelectedValue
        this.surveyForm.existingHouse = this.existingHouseSelectedValue
        axios.post(KG_URL.SURVEY + '/send', this.surveyForm)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              this.$router.push('/kagull/survey/complete')
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$refs.loadingModalRef.showModal(false)
          })
      } else {
        // オーダー家具のニーズ調査アンケートの場合
        this.surveyForm.place = this.placeSelectedValue
        this.surveyForm.timing = this.timingSelectedValue
        this.surveyForm.estimate = this.estimateSelectedValue
        this.surveyForm.roomImage = this.roomImageSelectedValue
        this.surveyForm.hobby = this.hobbySelectedValue
        this.surveyForm.taste = this.tasteSelectedValue
        axios.post(KG_URL.SURVEY + '/send-needs', this.surveyForm)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              this.$router.push('/kagull/survey/complete')
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$refs.loadingModalRef.showModal(false)
          })
      }
    }
  },
  computed: {
    isFamilySelected: function () {
      return this.surveyFormA.residentsSelected === 1
    },
    residentsSelectedValue: function () {
      // 居住形態
      return this.residentsOption.find(e => e.key === this.surveyFormA.residentsSelected).value
    },
    peopleSelectedValue: function () {
      // 人数
      return this.numberOfPeopleOption.find(e => e.key === this.surveyFormA.peopleSelected).value
    },
    childSelectedValue: function () {
      // 子供
      return this.numberOfPeopleOption.find(e => e.key === this.surveyFormA.childSelected).value
    },
    floorSelectedValue: function () {
      // 間取り
      return this.floorOption.find(e => e.key === this.surveyFormA.floorSelected).value
    },
    areaSelectedValue: function () {
      // 広さ
      return this.areaOption.find(e => e.key === this.surveyFormA.areaSelected).value
    },
    ageSelectedValue: function () {
      // 築年数
      return this.ageOption.find(e => e.key === this.surveyFormA.ageSelected).value
    },
    rentSelectedValue: function () {
      // 持ち家/賃貸
      return this.rentRadio.find(e => e.key === this.surveyFormA.rentSelected).value
    },
    housingTypesSelectedValue: function () {
      // 戸建て/マンション/その他
      return this.housingTypesRadio.find(e => e.key === this.surveyFormA.housingTypesSelected).value
    },
    existingHouseSelectedValue: function () {
      // 新築/中古
      return this.existingHouseRadio.find(e => e.key === this.surveyFormA.existingHouseSelected).value
    },
    placeSelectedValue: function () {
      // 家具が欲しい場所
      return this.placeOption.find(e => e.key === this.surveyFormB.placeSelected).value
    },
    timingSelectedValue: function () {
      // 家具が欲しい時期
      return this.timingOption.find(e => e.key === this.surveyFormB.timingSelected).value
    },
    estimateSelectedValue: function () {
      // 予算
      return this.estimateOption.find(e => e.key === this.surveyFormB.estimateSelected).value
    },
    roomImageSelectedValue: function () {
      // 部屋のイメージ
      return this.roomImageOption.find(e => e.key === this.surveyFormB.roomImageSelected).value
    },
    hobbySelectedValue: function () {
      // 趣味
      return this.hobbyOption.find(e => e.key === this.surveyFormB.hobbySelected).value
    },
    tasteSelectedValue: function () {
      // 好みの家具
      return this.tasteOption.find(e => e.key === this.surveyFormB.tasteSelected).value
    }
  },
  created: function () {
    // 表示アンケートの分岐の仮実装
    this.surveyType = 1
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/SurveyInput.vue